"use client";

import { cn } from "@/lib/utils";
import { ScrollReveal } from "@/components/ui/scroll-reveal";

// Данные трёх шагов подключения
const steps = [
  {
    number: "1",
    title: "Подключите магазин",
    description:
      "Введите API-ключ WB или Ozon. Read-only доступ — мы ничего не меняем. Занимает 2 минуты.",
  },
  {
    number: "2",
    title: "Загрузите себестоимость",
    description:
      "Excel-шаблон или вручную. Себестоимость рассчитается автоматически по партиям.",
  },
  {
    number: "3",
    title: "Получайте инсайты",
    description:
      "Прибыль по каждому артикулу, прогноз поставок, алерты когда товар уходит в минус.",
  },
] as const;

// Задержки появления шагов при скролле
const revealDelays = [0, 0.15, 0.3] as const;

export function HowItWorks() {
  return (
    <section
      id="how-it-works"
      className="py-24 px-6 border-t border-white/[0.06]"
    >
      <div className="max-w-5xl mx-auto">
        {/* Заголовок секции */}
        <ScrollReveal direction="up">
          <div className="text-center mb-16">
            <p className="text-sm font-medium text-purple-400 mb-3 uppercase tracking-widest">
              Как начать
            </p>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white tracking-tight">
              3 шага к прибыли
            </h2>
          </div>
        </ScrollReveal>

        {/* Сетка шагов — горизонтально на десктопе, вертикально на мобильных */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6">
          {steps.map((step, index) => (
            <ScrollReveal key={step.number} delay={revealDelays[index]}>
              <div
                className={cn(
                  "flex flex-col gap-4 p-6",
                  "border border-white/[0.08] bg-white/[0.02] rounded-2xl"
                )}
              >
                {/* Круг с номером шага */}
                <div className="w-10 h-10 rounded-full border border-white/[0.12] flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-bold text-sm text-center leading-none">
                    {step.number}
                  </span>
                </div>

                {/* Название и описание */}
                <div className="flex flex-col gap-2">
                  <h3 className="text-base font-semibold text-white">
                    {step.title}
                  </h3>
                  <p className="text-sm text-white/60 leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
